// MatchList (Domain/Customers, BL-189): what a search box's words match, in a framed list under the box,
// each an option drawn as a link that picks it: the customers found by a name, a number or a street (Book's customer, the
// way use-new-customer starts a new one when none is right). The box is a TextField with `combobox`,
// whose `controls` is this list's id. Draws from ready-to-show words. Reads only --matchlist-*.
import { ListBox, ListBoxItem } from 'react-aria-components';
import './MatchList.css';

export interface Match {
  id: string;
  /** "Okafor family" */
  name: string;
  /** Muted after the name: "Springfield" */
  detail?: string | null;
}

export interface MatchListProps {
  /** The id the box's `combobox.controls` names. */
  id: string;
  /** Said for the list: "Customers found". */
  label: string;
  items: readonly Match[];
  onPick: (id: string) => void;
}

export function MatchList({ id, label, items, onPick }: MatchListProps) {
  return (
    // a listbox of options, each picked by a tap or Enter: an option holds no button of its own
    <ListBox
      id={id}
      aria-label={label}
      className="fl-matchlist"
      items={items}
      selectionMode="none"
      onAction={(key) => onPick(String(key))}
    >
      {(m) => {
        const words = m.detail ? `${m.name} · ${m.detail}` : m.name;
        return (
          <ListBoxItem id={m.id} textValue={words} className="fl-matchlist__item">
            <span className="fl-matchlist__words">{words}</span>
          </ListBoxItem>
        );
      }}
    </ListBox>
  );
}
